import axios from "@/api/privateApi";
import { IndividualUpgrades, Recommendation } from "@/redux/myClub/myClubSlice";

type BackendRecommendation = Recommendation & {
  individualUpgrades: Omit<IndividualUpgrades, "positive">[];
};

type RecommendationsResponse = BackendRecommendation[];

export const getUserRecommendations =
  async (): Promise<RecommendationsResponse> => {
    const res = await axios.get<RecommendationsResponse>(
      "/user-squads/active/player-recommendations",
    );
    return res.data;
  };

export const markRecommendationsAsViewed = async (): Promise<void> =>
  axios.post("/user-squads/active/player-recommendations/mark-as-viewed");

export const computeNewPlayerRecs = async (): Promise<Recommendation[]> => {
  const res = await axios.post<Recommendation[]>(
    "/user-squads/active/player-recommendations?v=2",
  );
  return res.data;
};
